import { Injectable , Inject, PLATFORM_ID }    from '@angular/core';
import { AbstractControl } from '@angular/forms';
import Swal from 'sweetalert2';

@Injectable()

export class SweetAlert {    

	success(text : any){
		Swal.fire(' ', text, 'success')
	}
	error(text : any){
		Swal.fire(' ', text, 'error')
	}

	confirm(text : any){
		Swal.fire({
		text: text,
		icon: 'warning',
		showCancelButton: true,
		}).then((result : any) : any => {
		if (result.value) {
			return true;
		} else if (result.dismiss === Swal.DismissReason.cancel) {
			return false;
		}
		})
  }
 

}
